// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.jsdelivr.net/npm/keen-slider@5.5.1/+esm'

if (!customElements.get('product-technologies')) {
  customElements.define(
    'product-technologies',
    class ProductTechnologies extends window.BAO.CustomElement {
      constructor () {
        super()

        if (!this.els.slide || this.els.slide.elements.length < 2) return
        this.carousel = this.initialiseCarousel()
      }

      initialiseCarousel () {
        if (window.innerWidth > 768 && this.els.slide.elements.length === 2) {
          this.els.slides.element.classList.remove('car-Carousel_Slides')
          this.els.slides.element.classList.add('prd-Technologies_Items-double')

          this.els.slide.elements.forEach(slide => {
            slide.classList.remove('car-Carousel_Slide')
          })

          this.els.dots.element.classList.add('util-ScreenReaderOnly')

          return
        }

        if (window.innerWidth > 901 && this.els.slide.elements.length === 3) {
          this.els.slides.element.classList.remove('car-Carousel_Slides')
          this.els.slides.element.classList.add('prd-Technologies_Items-trio')

          this.els.slide.elements.forEach(slide => {
            slide.classList.remove('car-Carousel_Slide')
          })

          this.els.dots.element.classList.add('util-ScreenReaderOnly')

          return
        }

        if (this.els.slide.elements.length > 1) {
          this.els.slides.element.setAttribute(
            'data-custom-cursor-external-el',
            'carousel',
          )
        }

        return new KeenSlider(this.els.slides.element, {
          duration: 1000,
          mode: 'snap',
          slidesPerView: 1.3,
          slides: '.car-Carousel_Slide',
          spacing: 15,
          breakpoints: {
            '(min-width: 768px)': {
              centered: false,
              loop: true,
              mode: 'snap',
              slidesPerView: 1,
              spacing: 30,
            },
            '(min-width: 900px)': {
              centered: true,
              loop: true,
              mode: 'snap',
              slidesPerView: 4,
              spacing: 30,
            },
            '(min-width: 1300px)': {
              centered: true,
              loop: true,
              mode: 'snap',
              slidesPerView: 4,
              spacing: 30,
            },
          },
          move: instance => {
            this.els.slide.elements.forEach((slide, index) => {
              slide.setAttribute(
                'aria-hidden',
                index !== instance.details().relativeSlide,
              )
            })
          },
          created: instance => {
            this.els.dot.elements.forEach(dot => {
              dot.addEventListener('click', () => {
                instance.moveToSlide(dot.dataset.slide)
              })
            })
          },
          slideChanged: instance => {
            this.els.dot.elements.forEach(dot => {
              dot.setAttribute(
                'aria-current',
                parseInt(dot.dataset.slide) === instance.details().relativeSlide,
              )
            })
          },
        })
      }
    },
  )
}